/* Part Finder chat icon — click the icon: the chatbot opens in an iframe and draws itself with its own CSS. */
(function () {
    var me = document.currentScript;
    var chatUrl = (me && me.getAttribute("data-chat-url")) ||
        "https://d5715.www65-181-111-45.a2hosted.com/pf2/?embed=1";
    var chatOrigin = new URL(chatUrl).origin;

    function init() {
        var btn = document.createElement("button");
        btn.type = "button";
        btn.textContent = "💬";
        btn.setAttribute("aria-label", "Open Part Finder chat");
        btn.style.cssText = "position:fixed;right:20px;bottom:20px;z-index:2147483000;width:60px;height:60px;" +
            "border:0;border-radius:50%;cursor:pointer;background:#0f766e;color:#fff;font-size:26px;" +
            "box-shadow:0 6px 20px rgba(0,0,0,.28)";
        document.body.appendChild(btn);

        var frame = null;
        btn.addEventListener("click", function () {
            if (!frame) {                                   // created on the first click only
                frame = document.createElement("iframe");
                frame.src = chatUrl;
                frame.title = "Part Finder chat";
                frame.allow = "clipboard-write; camera";
                frame.style.cssText = "position:fixed;inset:0;width:100%;height:100%;border:0;" +
                    "z-index:2147483001;background:transparent";
                document.body.appendChild(frame);
            }
            frame.style.display = "block";
            btn.style.display = "none";
        });

        // the chat's own X button tells the page to close it
        window.addEventListener("message", function (e) {
            if (e.origin !== chatOrigin || !frame) return;
            if (e.data && e.data.source === "partfinder" && e.data.type === "close") {
                frame.style.display = "none";
                btn.style.display = "";
            }
        });
    }

    if (document.body) init();
    else document.addEventListener("DOMContentLoaded", init);
})();